import React from 'react'

const SvgPaintBucket = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.649 3.633c.49-.267.869-.472 1.477-.633l10.419 5.93-6.446 11.081a2.02 2.02 0 01-2.739.724L3.414 16.78a1.962 1.962 0 01-.734-2.7l.46-.86c.6.149 1.338.206 2.208.183l-.932 1.665 3.712 2.113 8.591-7.577L9.859 5.7 7.762 9.284c.423-.1.881-.219 1.377-.358a2.02 2.02 0 012.825-.887 1.962 1.962 0 01.734 2.7 2.021 2.021 0 01-3.353.183 27.26 27.26 0 01-2.786.622c-1.182.19-2.146.22-2.879.05-.77-.178-1.464-.638-1.64-1.49-.146-.707.144-1.405.45-1.93.645-1.098 1.875-2.288 3.092-3.213a14.643 14.643 0 012.068-1.328zM5.193 9.715l1.489-2.542c.046-.039.051-.053.029-.05l.54-.923c-.148.104-.297.214-.446.327-1.131.86-2.126 1.863-2.579 2.636-.139.237-.19.39-.209.473.03.01.069.022.121.034.22.05.56.077 1.055.045zM3.94 9.6s.006.003.013.01a.045.045 0 01-.013-.01z'
    />
    <path d='M19.995 18.264c1.107 0 2.005-.885 2.005-1.977 0-1.004-.848-2.67-1.765-4.47l-.24-.472-.24.473c-.917 1.799-1.765 3.465-1.765 4.469 0 1.092.897 1.977 2.005 1.977z' />
  </svg>
)

export default SvgPaintBucket
